import { render, staticRenderFns } from "./ruoRiExportRecords.vue?vue&type=template&id=41ccafe2&scoped=true&"
import script from "./ruoRiExportRecords.vue?vue&type=script&lang=js&"
export * from "./ruoRiExportRecords.vue?vue&type=script&lang=js&"
import style0 from "./ruoRiExportRecords.vue?vue&type=style&index=0&id=41ccafe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ccafe2",
  null
  
)

export default component.exports